module.exports = __webpack_public_path__ + "static/media/testomonialimg1.ecf242b4.webp";